import { type FC, ReactNode } from 'react';
import { BoxProps as GrommetBoxProps } from 'grommet';
import { Box, BoxProps, Card, CardBody } from '/src/components';

export const ChartCard: FC<ChartCardProps> = (props) => {
  const { innerBoxProps, cardHeader, children, ...boxProps } = props;
  // const { t } = useTranslation();

  /** Render **/
  return (
    <Card flex={{ shrink: 1, grow: 0 }} pad="medium" {...boxProps}>
      {cardHeader}
      <CardBody flex innerBoxProps={{ flex: true, elevation: 'none' }}>
        <Box flex elevation="none" {...innerBoxProps}>
          {children}
        </Box>
      </CardBody>
    </Card>
  );
};

export type ChartCardProps = BoxProps & {
  innerBoxProps?: GrommetBoxProps;
  cardHeader?: ReactNode;
};
